// import { io, Socket } from 'socket.io-client';

// let socket: Socket | null = null;

// export const connectSocket = (token: string) => {
//   if (!socket) {
//     socket = io(import.meta.env.VITE_SOCKET_URL || 'http://localhost:8000', {
//       auth: { token },
//       transports: ['websocket'],
//       withCredentials: true,
//     });
//     socket.on('connect', () => console.log('🔗 Socket connected'));
//     socket.on('disconnect', () => console.log('🔌 Socket disconnected'));
//     socket.on('connect_error', (err) => console.error('Socket error:', err));
//   }
//   return socket;
// };

// export const getSocket = () => {
//   if (!socket) throw new Error('Socket not connected');
//   return socket;
// };

// export const disconnectSocket = () => {
//   if (socket) {
//     socket.disconnect();
//     socket = null;
//   }
// };
import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export const connectSocket = (token: string) => {
  if (!socket) {
    socket = io(
      import.meta.env.VITE_SOCKET_URL || 'http://localhost:8000',
      {
        auth: {
          token,
        },
        transports: ['polling', 'websocket'],
        withCredentials: true,
        reconnection: true,
      }
    );

    socket.on('connect', () => {
      console.log('🔗 Socket connected:', socket?.id);
    });

    socket.on('disconnect', (reason) => {
      console.log('🔌 Socket disconnected:', reason);
    });

    socket.on('connect_error', (err) => {
      console.error('❌ Socket connection error:', err.message);
    });
  }

  return socket;
};

export const getSocket = () => {
  if (!socket) {
    throw new Error('Socket not connected');
  }

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};